import * as errorTypes from 'config/errorTypes';

export const GET_CAMPAIGN_ERROR = {
    [errorTypes.CAMPAIGN_NOT_FOUND]: r => r.httpStatus === 400 && r?.payload?.message === '404'
};

export const GET_MESSAGE_ERROR = {
    [errorTypes.MESSAGE_NOT_FOUND]: r =>
        r.httpStatus === 400 && r?.payload?.message === 'Campaign message not found'
};

export const UPDATE_CAMPAIGN_STATUS_ERROR = {
    [errorTypes.PUBLISH_CAMPAIGN_DOMAIN_WHITE_LIST_FAILED]: r =>
        r.httpStatus === 400 &&
        r?.payload?.message === 'sponsor setting validate failed - sdkDomainWhitelist',
    [errorTypes.PUBLISH_CAMPAIGN_TIMEZONE_VALIDATE_FAILED]: r =>
        r.httpStatus === 400 &&
        r?.payload?.message === 'campaign setting validate failed - timezone',
    [errorTypes.PUBLISH_CAMPAIGN_PLAN_VALIDATE_FAILED]: r =>
        r.httpStatus === 401 && r?.payload?.message === 'Plan validate failed'
};
